import { Message } from 'semantic-ui-react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import Selectors from '@/vocabularies/hooks/selectors';
import MarkdownRender from '@/components/text-editors/MarkdownRender';
import { successfulPollingStatuses } from '../constants';

const RequestConfirmationMessage = ({ polling }) => {
  const { content } = Selectors.useRequestConfirmationMessage();
  if (!successfulPollingStatuses.includes(polling) || !hasMinimumLength(content)) {
    return null;
  }

  return (
    <Message info size="small">
      <Message.Content>
        <MarkdownRender value={content} />
      </Message.Content>
    </Message>
  );
};

export default RequestConfirmationMessage;
